"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concat = void 0;

/**
 * Merge two or more arrays into one
 *
 * @param {Array}  source1  First array
 * @param {Array}  source2  Second array
 *
 * @returns {Array}
 *
 * @tag Array
 * @signature (source1: Array) => (source2: Array) => Array
 *
 * @example
 * concat([1])([4, 5])
 * // => [1, 4, 5]
 */
var concat = function concat(source1) {
  return function (source2) {
    return source1.concat(source2);
  };
};

exports.concat = concat;